import {
  BUSINESS_MODEL_PARAM,
  ACCOUNT_PARAM,
  CHANNEL_PARAM,
} from "../../hooks/useQueryParams";
import { FE_TO_BE_VALUES } from "../../constants/app.constants";

export const MENU_ACCESSORS = [
  CHANNEL_PARAM,
  BUSINESS_MODEL_PARAM,
  ACCOUNT_PARAM,
] as const;

type MENU_ACCESSOR_KEYS = (typeof MENU_ACCESSORS)[number];
export const recurseOverCountry = (
  val: { [key: string]: any },
  sets: {
    [K in MENU_ACCESSOR_KEYS]: Set<{ label: string; value: string }>;
  },
  labels: Set<string>,
  level = 0,
) => {
  if (!val || typeof val === "string") {
    return;
  }
  const keys = Object.keys(val);

  if (!keys) {
    return;
  }
  return keys.forEach((key) => {
    const value = val[key];
    if (typeof value === "string" && !labels.has(key)) {
      sets[MENU_ACCESSORS[level]].add({
        label: key,
        value: FE_TO_BE_VALUES[key],
      });
      labels.add(key);
    } else {
      if (!labels.has(key)) {
        sets[MENU_ACCESSORS[level]].add({
          label: key,
          value: FE_TO_BE_VALUES[key] ?? key,
        });
        labels.add(key);
      }
      recurseOverCountry(val[key], sets, labels, level + 1);
    }
  });
};

export const navBuilder = (
  menuData: { label: string; value: string }[],
  checks: Set<string>,
  menuParamName: MENU_ACCESSOR_KEYS,
  setParamsCallback: (parameterName: string, value: string) => void,
) => {
  for (let item of menuData) {
    if (checks.has(item.value.toLowerCase())) {
      setParamsCallback(menuParamName, item.value.toLowerCase());
    }
  }
};
